export default __webpack_public_path__ + "static/media/house.c4a1b420.svg";